const slSlide = (() => {
  const pageSeniorLohas = (document.getElementById("pageSeniorLohas") != null);
  if (pageSeniorLohas) {


    let sW = window.innerWidth;

    let slidesPerView;
    let spaceBetween;

    if (sW > 750) {
      slidesPerView = 1.6
      spaceBetween = 70
    } else {
      slidesPerView = 1.0
      spaceBetween = 40
    }


    const swiper = new Swiper("#jsSwiper", {
      loop: true,
      // centeredSlides: true,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      speed: 800,
      navigation: {
        nextEl: ".swiper-btn-next",
        prevEl: ".swiper-btn-prev"
      }
    });

    let swiperCopy = document.getElementById("jsSwiperCopy")
    let lead = swiperCopy.querySelector('.js-lead');
    let txt = swiperCopy.querySelector('.js-txt');
    let label = swiperCopy.querySelector('.js-label p');
    swiper.on('slideChange', function () {
      if (swiper.realIndex == 0) {
        lead.textContent = `ウォーキングでウェルネス向上`;
        txt.textContent = `こころに越してきてから身に付いた習慣が、夫婦でウォーキング。道幅が広く平坦で歩きやすいので、昼夜問わず、時間があるときはどちらからともなく誘うように。目標は20年先も健康な体でいること。`;
        label.textContent = `#Walking`;
      } else if (swiper.realIndex == 1) {
        lead.textContent = `休日はアクティブにドライブ`;
        txt.textContent = `夫婦の楽しみのひとつが、休日のドライブをかねた道の駅めぐり。1時間ちょっとで行ける「来夢とごうち」がお気に入りで、にぎわう景色を眺めながらレストランで食事が定番に。帰りはいつもお土産がいっぱい。`;
        label.textContent = `#Driveg`;
      } else if (swiper.realIndex == 2) {
        lead.textContent = `美味しいコーヒーでオウチカフェ`;
        txt.textContent = `朝は豆を挽くことから始まり、午後はスイーツと一緒に。好きなコーヒーを楽しむ妻の演出は、いつも格別だ。最近は「パティスリーマチルダ」のケーキやショコラが、ワンランク上のカフェタイムを飾ってくれている。`;
        label.textContent = `#Caffee`;
      } else if (swiper.realIndex == 3) {
        lead.textContent = `豊かな自然のなかレジャーを満喫`;
        txt.textContent = `娘家族と一緒に土師ダムへピクニックに。芝生広場でお弁当を広げ、午後はみんなでサイクリング。大自然を遊び場に孫も楽しみ、休日の良いリフレッシュに。次は連休を利用してキャンプに挑戦してみよう。`;
        label.textContent = `#Camping`;
      } else if (swiper.realIndex == 4) {
        lead.textContent = `外出する機会が増え、趣味も幅広く`;
        txt.textContent = `歩いて行ける場所にグランドゴルフの教室を発見。夫婦で初めてやってみたけど、なかなか楽しい。カラダを動かすことが心地よい環境なので、まだいろいろチャレンジしてみたい。長く続けられる趣味をもっと増やしていこう。`;
        label.textContent = `#GroundGolf`;
      } else if (swiper.realIndex == 5) {
        lead.textContent = `地域交流で広がる人の輪が活力に`;
        txt.textContent = `地域活動に積極的な夫は、団地内でもさまざまな活動に参加。清掃や見守りなど、子どもから大人まで顔をあわせて、交流を楽しんでいる様子。おかげで顔見知りが増えて、若い世代との会話も増えたことが嬉しい。`;
        label.textContent = `#Volunteer`;
      }
    });





  }
})();
export default slSlide;